import { useState } from 'react';
import { Outlet } from 'react-router';
import { SideNav, SideNavMobile, SettingsModal } from '../components';

const DashboardLayout = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => setIsCollapsed((prev) => !prev);

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-base-100 text-base-content">
      {/* <TopNav user={user} /> */}
      <div className="flex flex-col md:flex-row h-full md:h-dvh">
        <aside
          className={`${isCollapsed ? 'w-20 p-2' : 'w-60 lg:w-72 p-4 lg:px-7'} hidden md:flex
        h-auto bg-base-200 flex-col justify-between
        transition-all duration-150 ease-linear
        border-r border-[var(--light-gray)]`}
        >
          <SideNav isCollapsed={isCollapsed} toggleCollapse={toggleCollapse} />
        </aside>
        <aside className="flex flex-col md:hidden w-full bg-base-200 overflow-y-block flex-shrink-0">
          <SideNavMobile />
        </aside>
        <div className="flex-1 overflow-y-auto overflow-x-hidden min-h-0">
          <Outlet />
        </div>
      </div>
      {/* Global modals */}
      <SettingsModal modalId="settings-modal" />
    </div>
  );
};

export default DashboardLayout;
